// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SpecimenSampleEditForm__wrapper__1N7oB","submitResult":"SpecimenSampleEditForm__submitResult__1KT8u","actionWrapper":"SpecimenSampleEditForm__actionWrapper__1ZYve","wrapper2faOptions":"SpecimenSampleEditForm__wrapper2faOptions__2D2s7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SpecimenSampleEditor/SpecimenSampleEditForm/SpecimenSampleEditForm.css
// module id = 3261
// module chunks = 0